import { IEecsCompany } from 'modules/eecs-go/eecs-company';

export enum EEcsWhiteListStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export interface IEecsWhiteList {
  id: number;
  organization_name: string;
  target_company_id: number;
  status: EEcsWhiteListStatus;
  last_request_date: string;
  is_requesting_company: boolean;
}

export interface EecsAddWhiteListPayload {
  target_company_id: number;
}

export interface EecsUpdateWhiteListPayload {
  id: number;
  status: EEcsWhiteListStatus;
}

export interface EecsDeleteWhiteListPayload {
  id: number;
}

export enum EEecsWhiteListModals {
  ADD_PARTNER = 'add_partner',
  CONFIRM = 'confirm',
}

export enum EEecsWhiteListModalAction {
  DELETE = 'delete',
  ADD_CONFIRM = 'add_confirm',
  ADDED_INFO = 'added_info',
  REJECT = 'reject',
  CANCEL = 'cancel',
  ACCEPT = 'accept',
}

export interface EecsWhiteListModalPayload {
  action?: EEecsWhiteListModalAction;
  eecsCompany?: IEecsCompany;
}

export interface IEecsWhiteListModal {
  type: EEecsWhiteListModals;
  payload?: EecsWhiteListModalPayload;
}
